// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  sdpApiUrl: 'https://donate-api-staging.scout.org/api/v1',
  sdpUrl: 'https://donate-staging.scout.org',
  gsWebUrl: 'https://stg2-services.scout.org',
  servicesUrl: 'https://treehouse.scout.org',
  hostUrl: 'https://stg-members.scout.org',
  apiUrl: 'https://stg-members.scout.org',
  scoutOrgUrl: 'https://api-staging.scout.org/',
  intranetUrl: 'https://staging.scout.org/members',
  idmAccountUrl: 'https://stg-sso.scout.org/auth/realms/wsb/account/',
  idmConsoleURL: 'https://stg-sso.scout.org/auth/admin/wsb/console/#/realms/wsb/users/',
  idmAuthURL: 'https://stg-sso.scout.org/auth'
};
